import React from "react";
import Navbar from "./Navbar";
import { HashLink as Link } from "react-router-hash-link";

export const Header = () => {
  return (
    <header className="header header--home" role="banner">
      <div className="site-header">
        <div className="container">
          <Navbar />
        </div>
      </div>

      {/* Hero */}
      <section className="section hero" aria-labelledby="hero-title">
        <div className="container grid-2">
          <div className="hero-copy">
            <h1 id="hero-title">
              La fidélité. <br className="br-md" />Sans contrainte.
            </h1>
            <p className="sub">
              Toujours avec vos clients. Toujours dans leur poche.
            </p>
            <div className="cta-row">
              <Link smooth to="/#features" className="btn">
                Découvrir Carte Verte
              </Link>
            </div>
          </div>

                  <img
                    className="phone-hero__img"
                    src="/images/hero-image.svg"
                    alt="Smartphone affichant une carte de fidélité"
                  />
        </div>
      </section>
    </header>
  );
};

export default Header;
